import { TrackingSpeedEventSeverity } from '@cobliteam/api-lib';
import { Severity } from '@cobliteam/common-types';

export const trackingSeverityToSeverity = {
  [TrackingSpeedEventSeverity.MEDIUM]: Severity.MEDIUM,
  [TrackingSpeedEventSeverity.HIGH]: Severity.SEVERE,
  [TrackingSpeedEventSeverity.HIGHER]: Severity.VERY_SEVERE,
};
